import React from 'react';

/**
 * En-tête de colonne triable (tri côté API). Clic : tri sur la colonne, re-clic :
 * inverse le sens. `sort` = { key, dir } courant ; sans `sortKey`, en-tête simple.
 */
export default function SortableTh({ label, sortKey, sort, onSort, style }) {
  if (!sortKey) return <th style={{ ...styles.th, ...style }}>{label}</th>;
  const active = sort.key === sortKey;
  const next = active && sort.dir === 'desc' ? 'asc' : 'desc';
  return (
    <th style={{ ...styles.th, ...style }} aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <button type="button" onClick={() => onSort({ key: sortKey, dir: active ? next : 'desc' })}
              style={{ ...styles.btn, ...(active ? styles.active : {}) }}>
        {label}
        <span style={{ opacity: active ? 1 : 0.35 }}>{active ? (sort.dir === 'asc' ? '▲' : '▼') : '↕'}</span>
      </button>
    </th>
  );
}

const styles = {
  th: { padding: '0.75rem 1rem', textAlign: 'left', whiteSpace: 'nowrap' },
  btn: {
    display: 'inline-flex', alignItems: 'center', gap: '0.3rem', background: 'none', border: 'none', padding: 0,
    font: 'inherit', color: 'inherit', textTransform: 'inherit', cursor: 'pointer', letterSpacing: 'inherit',
  },
  active: { color: '#232853' },
};
